var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTap(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 321 321",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-357,-1097)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "user",
    transform: "matrix(0.3125,0,0,0.16,21.7447,1097.84)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1074,
    y: 0,
    width: 1024,
    height: 2000,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.86667,0,0,7.5521,-1430,-12367.3)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,120,10)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M540,1660L580,1680L580,1780L540,1800L540,1660Z",
    style: {
      fill: "none",
      stroke: "rgb(51,51,51)",
      strokeWidth: "12.44px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,120,10)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M580,1705L760,1705C773.581,1706.13 780.061,1712.95 780,1725L780,1785L730,1785L730,1755L580,1755L580,1705Z",
    style: {
      fill: "none",
      stroke: "rgb(51,51,51)",
      strokeWidth: "12.44px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,120,10)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M700,1660L700,1700L700,1660Z",
    style: {
      fill: "none",
      stroke: "rgb(51,51,51)",
      strokeWidth: "12.44px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,120,10)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 640,
    y: 1640,
    width: 120,
    height: 20,
    style: {
      fill: "none",
      stroke: "rgb(51,51,51)",
      strokeWidth: "12.44px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,130.43,9.98109)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M744.57,1810.02C753.362,1823.35 760.326,1836.69 764.57,1850.02C770.25,1870.75 763.441,1880.21 744.57,1880.02C726.081,1880.46 716.686,1873.23 724.57,1850.02C729.261,1838.17 736.24,1824.6 744.57,1810.02Z",
    style: {
      fill: "none",
      stroke: "rgb(51,51,51)",
      strokeWidth: "12.44px"
    }
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTap);
export default __webpack_public_path__ + "static/media/tap.b1c34594cf9cbeca5d0d9be790e35eab.svg";
export { ForwardRef as ReactComponent };